import { Injectable, inject, signal } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, catchError, map, shareReplay, tap } from 'rxjs';
import { AutomatedTransfersAlarmNotificationsParams } from '../../../../../../pages/transfers/automated-transfers/contract/automated-transfers-alarm-notifications-params.contract';
import { AutomatedTransfersNotificationsApiService } from '../../../../../../pages/transfers/automated-transfers/services/automated-transfers-notifications-api.service';
import { AcknowledgeAutomatedTransferNotificationCommand } from '../../../../../../pages/transfers/contract/acknowledge-automated-transfer-notificaton-command.contract';
import { AutomatedTransferNotification } from '../../../../../../pages/transfers/contract/automated-transfer-notification.contract';

@Injectable({ providedIn: 'root' })
export class AutomatedTransfersNotificationsDatasourceService {
  private readonly automatedTransfersNotificationsApiService = inject(AutomatedTransfersNotificationsApiService);

  private _currentActive$ = new BehaviorSubject<AutomatedTransferNotification[]>([]);
  private _currentActiveTotalCount$ = new BehaviorSubject<number>(0);

  public readonly currentActive$ = this._currentActive$.asObservable();
  public readonly currentActiveTotalCount$ = this._currentActiveTotalCount$.asObservable();
  public readonly currentActiveCountUpdates$ = this.automatedTransfersNotificationsApiService
    .getCurrentActiveCount()
    .pipe(
      map((res) => res?.count ?? 0),
      tap((count) => this._currentActiveTotalCount$.next(count)),
      catchError((err) => {
        console.error('AT notification active count SSE error:', err);
        return EMPTY;
      }),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

  private readonly CURRENT_ACTIVE_PAGE_SIZE = 5000; // proper pagination requires to rethink the UI's approach
  private readonly CURRENT_ACTIVE_PAGE = 0;
  private readonly CURRENT_ACTIVE_REQUEST_PARAMS: AutomatedTransfersAlarmNotificationsParams = {
    size: this.CURRENT_ACTIVE_PAGE_SIZE,
    page: this.CURRENT_ACTIVE_PAGE,
    sort: 'creationDate,desc',
  };

  $isNotificationsError = signal(false);

  public refreshCurrentActive(): Observable<AutomatedTransferNotification[]> {
    return this.automatedTransfersNotificationsApiService.getCurrentActive(this.CURRENT_ACTIVE_REQUEST_PARAMS).pipe(
      map((res) => res.content),
      tap((notifications) => {
        this._currentActive$.next(notifications);
        this.$isNotificationsError.set(false);
      }),
      catchError(() => {
        this.$isNotificationsError.set(true);
        return EMPTY;
      }),
    );
  }

  public acknowledgeAutomatedTransferNotification(
    command: AcknowledgeAutomatedTransferNotificationCommand,
  ): Observable<string> {
    return this.automatedTransfersNotificationsApiService.acknowledgeAutomatedTransferNotification(command);
  }

  public acknowledgeAllAutomatedTransferNotifications(): Observable<void> {
    return this.automatedTransfersNotificationsApiService.acknowledgeAllAutomatedTransferNotifications();
  }
}
